export default __webpack_public_path__ + "static/media/Y17.3f1e8548.jpg";